
import "./internal.css";

import { useState, useEffect } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, getDocs, getDoc, addDoc, doc, query, where, updateDoc, limit } from "firebase/firestore";



export default function Details() {


    async function criar_plano(data) {

        try {

            let dt = new Date();
    
            const plandoc = await addDoc(collection(db, "plans"), 
            { 
                codigo: "EST1",
                ramo: "Esteticistas",
                atendimento: "W",
                valor: 6,
                data_criacao: dt,
                data_inicio_vigencia: dt,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            })

            console.log("criado");
        }

        catch(erro) {
            console.log(erro);
        }

    }



    return(
        <div>
            
            <span>Para criar um plano</span>
            <br />
            <br />
            <div><button input="button" onClick={criar_plano}>Criar Plano</button></div>
            

        </div>
    )
}